import { Base } from 'layouts'
import { IndustryGroupForm } from 'components'

import * as S from './styled'

export function IndustryGroupEdit() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryGroupForm />
      </S.GridContainer>
    </Base>
  )
}
